import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home";
import About from "./pages/About";
import Dagopvang from "./pages/Dagopvang";
import Logeeropvang from "./pages/Logeeropvang";
import VoorWie from "./pages/VoorWie";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import Privacy from "./pages/Privacy";
import AlgemeneVoorwaarden from "./pages/AlgemeneVoorwaarden";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/over-ons" element={<About />} />
          <Route path="/dagopvang" element={<Dagopvang />} />
          <Route path="/logeeropvang" element={<Logeeropvang />} />
          <Route path="/voor-wie" element={<VoorWie />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/veelgestelde-vragen" element={<FAQ />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/algemene-voorwaarden" element={<AlgemeneVoorwaarden />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
    </HelmetProvider>
  );
}

export default App;
